/**
 * @description: 入口
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// url
Vue.ctUrl = "https://test-pc.g-hi.com/pc-251202/";
let pathName = window.location.pathname.substring(1);
let branch_url_date = pathName == '' ? '' : pathName.substring(0, pathName.indexOf('/'));
if(window.location.host.indexOf('localhost') < 0) {
  Vue.ctUrl = "https://" + window.location.host + "/" + branch_url_date + "/";
}

Vue.request_header = {
  "data_type": "normal",
  "data_direction": "request",
  "server": "YoucManage",
  "id": "YoucManage",
  "merchant_id": store.state.mercid
}
Vue.timeoutfun = function(datas, _this) {
  if(datas == -99) {
    // 登录超时
    Vue.request_header.merchant_id = ''
    _this.$router.push({
      path: "/login"
    })
  } else if(datas == -100) {
    // 登录 A 账号，又登录 B 账号，操作 A 账号提示登录超时
    // _this.$router.push({
    //   path: "/"
    // })
    _this.$router.push({
      name: 'index',
      params: {
        code: '-100'
      }
    })
  }
}
Vue.accMul = function(arg1, arg2) {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length
  } catch(e) {}
  try {
    m += s2.split(".")[1].length
  } catch(e) {}
  var result = Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
  result = Vue.toDecimal2(result);
  return result
}
Vue.toDecimal2 = function(x) {
  var f = parseFloat(x);
  if(isNaN(f)) {
    return false;
  }
  var f = Math.round(x * 100) / 100;
  var s = f.toString();
  var rs = s.indexOf('.');
  if(rs < 0) {
    rs = s.length;
    s += '.';
  }
  while(s.length <= rs + 2) {
    s += '0';
  }
  return s;
}

// 常量
import global from "./components/global"
Vue.prototype.GLOBAL = global

// element-ui
import {
  Table,
  TableColumn,
  Pagination,
  Loading,
  Button,
  Form,
  FormItem,
  Input,
  Autocomplete,
  Select,
  Option,
  Row,
  Col,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  DatePicker,
  Icon,
  Popover,
  Tabs,
  TabPane,
  Menu,
  Submenu,
  MenuItem,
  Image,
  TimePicker,
  Dialog
} from "element-ui"

Vue.use(Pagination)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Autocomplete)
Vue.use(Select)
Vue.use(Option)
Vue.use(Row)
Vue.use(Col)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(DatePicker)
Vue.use(Icon)
Vue.use(Popover)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Image)
Vue.use(TimePicker)
Vue.use(Dialog)
// vue-axios
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
// 配置 aixos 默认值
axios.defaults.withCredentials = true
axios.defaults.crossDomain = true
axios.defaults.baseURL = Vue.ctUrl
axios.defaults.transformRequest = [function(data) {
  return JSON.stringify(data)
}]

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
